import React from "react";

// expects roles = [{id,name,isSystem,userCount}] and selectedId/onSelect
export default function RoleList({ roles, selectedId, onSelect }) {
  if (!roles.length) {
    return <div className="rm-empty">No roles found.</div>;
  }

  return (
    <div className="rm-role-list">
      <ul>
        {roles.map((role) => (
          <li
            key={role.id}
            className={role.id === selectedId ? "selected" : ""}
            onClick={() => onSelect(role.id)}
          >
            <span className="rm-role-name">
              {role.name}{" "}
              {role.isSystem && <span className="rm-sys-badge">System</span>}
            </span>
            <span className="rm-role-permcount">
              {role.permissions ? role.permissions.length : 0} perms
            </span>
            <span className="rm-role-count">{role.userCount || 0} users</span>
            {role.isSystem && (
              <span
                className="rm-sys-tooltip"
                title="System role - cannot be modified"
              >
                i
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
